import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  hourlyDetailTile: {
    backgroundColor: Theme.white,
    borderRadius: Theme.tileBorderRadius,
    height: Theme.px(278),
    letterSpacing: Theme.px(0),
    marginRight: Theme.px(12),
    opacity: 0.05,
    width: Theme.px(240),
  },
  hourlyPageErrorImage: {
    height: Theme.px(201),
    width: Theme.px(307),
  },
  hourlyPageErrorText: {
    paddingLeft: Theme.px(87),
    width: Theme.px(525),
  },
  hourlyPageErrorWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: Theme.px(75),
    width: '100%',
  },
  rowWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  wrapper: {
    paddingTop: Theme.px(61),
  },
});
